module.exports = __webpack_public_path__ + "static/media/slice.86fb8a41.png";